import React from 'react';
import clsx from 'clsx';
import styles from './PlateChunk.module.scss';

/**
 * Lowest-level Slate chunk wrapper (Plate `chunking.contentVisibilityAuto`).
 *
 * MUST be a plain function: slate-react calls `renderChunk(props)` as a
 * function, not as a React element. A `React.memo` object is not callable and
 * crashes the editor (`renderChunk is not a function`).
 *
 * Plate's default `ContentVisibilityChunk` only sets `content-visibility: auto`,
 * which skips off-screen paint but collapses skipped chunks to 0 height —
 * the scrollbar jumps and the browser has to relayout on every scroll.
 * `contain-intrinsic-size: auto 5rem` keeps a stable estimate until the
 * chunk paints (tables are much taller than a body line; 1.5rem made the
 * scrollbar collapse on oversized CAMs).
 */
export function renderPlateChunk({
    attributes,
    children,
    lowest,
}: {
    attributes?: Record<string, unknown>;
    children?: React.ReactNode;
    lowest?: boolean;
}) {
    if (!lowest) return children as React.ReactElement;
    const { className, ...rest } = (attributes ?? {}) as { className?: string };
    return (
        <div {...rest} className={clsx(styles.Chunk, className)}>
            {children}
        </div>
    );
}
